module.exports = __webpack_public_path__ + "img/kuaihe.a5f8ecd0.jpg";